/**
 * 関連する求人情報
 */
import $ from 'jquery'

export default function () {

  const $tgt = $('.js-recruit-relative');
  const $noitem = $('.js-recruit-relative__noitem');

  if ($tgt.length > 0) {
    const all_num = $('.js-recruit-relative li').length;
    console.log(all_num);
    const not_num = $('.js-recruit-relative li.js-notfound').length;
    console.log(not_num);

    if (all_num === not_num) {
      $noitem.show();
    } else {
      $noitem.hide();
    }
  } else {
    $noitem.show();
  }
}

/**
 * 実行
 */
// setRecruitRelative()
